import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileUp, Eye, Trash2, Loader2 } from "lucide-react";
import { api, extractErrorMessage } from "@/lib/api";

export const DOC_KINDS = [
  { k: "ise_giris", label: "İşe Giriş Bildirgesi" },
  { k: "ise_cikis", label: "İşten Çıkış Bildirgesi" },
];

export const uploadPersonnelDoc = (pid, kind, file) => {
  const fd = new FormData();
  fd.append("kind", kind);
  fd.append("file", file);
  return api.post(`/personnel/${pid}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } });
};

export const openDoc = async (d) => {
  try {
    const r = await api.get(`/personnel/documents/${d.id}/download`, { responseType: "blob" });
    window.open(window.URL.createObjectURL(new Blob([r.data], { type: d.content_type })), "_blank");
  } catch { toast.error("Belge açılamadı"); }
};

export const PersonnelDocsField = ({ personnelId, pending, setPending }) => {
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => personnelId && api.get(`/personnel/${personnelId}/documents`).then((r) => setDocs(r.data.rows)).catch(() => {});
  useEffect(() => { load(); }, [personnelId]); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = async (kind, file) => {
    if (!file) return;
    if (!personnelId) { setPending({ ...pending, [kind]: file }); return; }
    setBusy(kind);
    try { await uploadPersonnelDoc(personnelId, kind, file); toast.success("Belge yüklendi"); load(); }
    catch (e) { toast.error(extractErrorMessage(e, "Yüklenemedi")); } finally { setBusy(""); }
  };
  const remove = async (d) => {
    if (!window.confirm("Belge silinsin mi?")) return;
    try { await api.delete(`/personnel/documents/${d.id}`); load(); } catch { toast.error("Silinemedi"); }
  };

  return (
    <div className="grid grid-cols-2 gap-3" data-testid="personnel-docs">
      {DOC_KINDS.map(({ k, label }) => {
        const d = docs.find((x) => x.kind === k);
        const pf = pending?.[k];
        return (
          <div key={k} className="border border-dashed border-slate-300 rounded-lg p-2.5 bg-slate-50/60">
            <div className="text-[11px] font-bold text-slate-700 mb-1">{label}</div>
            {d && (
              <div className="flex items-center gap-1 text-[11px] mb-1" data-testid={`doc-${k}-existing`}>
                <span className="truncate flex-1 text-emerald-700 font-semibold" title={d.original_filename}>{d.original_filename}</span>
                <button type="button" onClick={() => openDoc(d)} data-testid={`doc-${k}-view`} className="p-1 rounded hover:bg-slate-200"><Eye size={12} /></button>
                <button type="button" onClick={() => remove(d)} data-testid={`doc-${k}-delete`} className="p-1 rounded hover:bg-rose-100 text-rose-700"><Trash2 size={12} /></button>
              </div>
            )}
            {pf && <div className="text-[11px] text-amber-700 truncate mb-1" data-testid={`doc-${k}-pending`}>Kayıtta yüklenecek: {pf.name}</div>}
            <label className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-700 cursor-pointer px-2 py-1 border border-slate-300 rounded bg-white hover:bg-slate-100">
              {busy === k ? <Loader2 size={12} className="animate-spin" /> : <FileUp size={12} />}
              {d || pf ? "Değiştir" : "Dosya Seç"}
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" data-testid={`doc-${k}-input`}
                onChange={(e) => { pick(k, e.target.files?.[0]); e.target.value = ""; }} />
            </label>
            <span className="text-[10px] text-slate-400 ml-1">PDF/JPG/PNG · 10 MB</span>
          </div>
        );
      })}
    </div>
  );
};
